export type CTraderCommandMapParameters = {
    send: (...parameters: any[]) => void;
};
